export const MESSAGES = {
  SWITCH_CONFIRM_TITLE: '确认关闭版本开关？',
  SWITCH_CONFIRM_CONTENT:
    'App 应用提审期间 ，需跟 Kaito或Jiang.Jinlai确认之后再打开',
  SWITCH_WARNING: 'App 应用提审期间 ，需跟 Kaito或Jiang.Jinlai确认之后再打开',
  DELETE_CONFIRM: '确定要删除这个版本吗？',
  SUCCESS_MESSAGES: {
    SWITCH_ON: '开启成功',
    SWITCH_OFF: '关闭成功',
    DELETE: '删除成功',
  },
  ERROR_MESSAGES: {
    SWITCH: '修改版本开关状态失败',
    DELETE: '删除失败',
    FETCH_SWITCH: '获取版本开关状态失败',
  },
} as const;

export const DEFAULT_SWITCH_STATUS = 1;
